const DEFAULT_LOCALE = { code: 'en-MY', currency: 'MYR' };

export const removeThousandSeparator = (val) => {
  const stringNum = String(val).replace(/[,]/g, "");
  return Number(stringNum);
}

function processInput(inputValue) {
  if (inputValue == null || Number.isNaN(inputValue)) return null;
  if (typeof inputValue === 'string') return removeThousandSeparator(inputValue)
  return Number(inputValue);
}

export function fCurrency(inputValue, options) {
  const locale = DEFAULT_LOCALE;

  const number = processInput(inputValue);
  if (number === null) return '';

  const fm = new Intl.NumberFormat(locale.code, {
    style: 'currency',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol',
    ...options,
    currency: options?.currency || locale.currency,
  }).format(number);

  return fm;
}

export const safeJsonParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}
